enum CommunityTypeEnum {
  AllAges = 'All Ages',
  Restricted = 'Restricted',
}

export default CommunityTypeEnum;
